import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import type { GlobalConcreteOrderOption } from '@/types/global-concrete-order';

export const useGlobalConcreteOrderOptions = (chantierId: string) => {
  const [options, setOptions] = useState<GlobalConcreteOrderOption[]>([]);
  const [loading, setLoading] = useState(false);
  const fetchOptions = async () => {
    if (!chantierId) return;

    setLoading(true);
    try {
      const { data: commandeGlobaleData, error: cgError } = await supabase
        .from('global_orders' as any)
        .select('id')
        .eq('site_id', chantierId)
        .limit(1) as any;

      if (cgError) throw cgError;
      const commandeGlobale = commandeGlobaleData?.[0];
      if (!commandeGlobale) {
        setOptions([]);
        return;
      }

      const { data, error } = await supabase
        .from('order_supplier_options' as any)
        .select('*')
        .eq('order_id', commandeGlobale.id)
        .eq('active', true)
        .order('category', { ascending: true }) as any;

      if (error) throw error;

      setOptions(data || []);
    } catch (error: any) {
      toast.error("Erreur", { description: "Impossible de charger les options"});
      setOptions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, [chantierId]);

  return { options, loading, refetch: fetchOptions };
};
